<template>
    <AnsPopup
        v-if="isPopupVisible"
        :is-visible="isPopupVisible"
        :title="popupConfig.title"
        :logo-src="popupConfig.logoSrc"
        :dimensions="popupConfig.dimensions"
        :styles="popupConfig.styles"
        :classes="popupConfig.classes"
        :options="popupConfig.options"
        @close="handleClose"
    >
        <component :is="popupComponent" v-bind="componentProps" @select="handleSelect" @close="handleClose" v-on="eventHandlers" />
    </AnsPopup>
</template>

<script>
/**
 * ****************************************************************************
 * @description     :   Global Popup Component
 * @created at      :   2025/08/01
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import { mapMutations, mapState } from 'vuex';
import AnsPopup from '@/components/ansPopup/index.vue';

export default {
    name: 'GlobalPopup',
    components: {
        AnsPopup
    },
    computed: {
        ...mapState('app', {
            isPopupVisible: (state) => state.popup.isVisible,
            popupComponent: (state) => state.popup.component,
            componentProps: (state) => state.popup.componentProps,
            onSelect: (state) => state.popup.onSelect,
            eventHandlers: (state) => state.popup.eventHandlers,
            popupConfig: (state) => ({
                title: state.popup.title,
                logoSrc: state.popup.logoSrc,
                dimensions: state.popup.dimensions,
                styles: state.popup.styles,
                classes: state.popup.classes,
                options: state.popup.options
            })
        })
    },
    methods: {
        ...mapMutations('app', ['hidePopup']),
        handleClose() {
            this.hidePopup();
        },
        handleSelect(data) {
            console.log('handleSelect', data);
            if (this.onSelect && typeof this.onSelect === 'function') {
                this.onSelect(data);
            }
        }
    }
};
</script>
